import { SearchItem } from 'types'

// CONSTANTS
export const Constants = {
  SET: 'SET_SEARCH_ITEM',
}

// ACTION TYPES
export type SearchReduxAction = {
  type: typeof Constants.SET
  payload: SearchItem
}

// ACTION CALLS
export const Actions = {
  SET: (payload: SearchItem): SearchReduxAction => ({
    type: Constants.SET,
    payload,
  }),
}
